import type { ParsePayload, Schema } from './types'
import { prefixIssues } from './util'

// Ported from Zod 4.5.4 schemas.ts handlePropertyResult, pinned in UPSTREAM.md.
export function completeObjectProperty(key: PropertyKey, child: Schema, parsed: ParsePayload, payload: ParsePayload, input: object, result: Record<PropertyKey, unknown>) {
  const present = key in input
  const { optin, optout } = child._zod
  if (!present && optout === 'optional' && optin === 'optional') return
  if (parsed.issues.length > 0) {
    if (optin !== undefined && optout === 'optional' && !present) return
    payload.issues.push(...prefixIssues(key, parsed.issues))
  }
  if (!present && optin === undefined) {
    if (parsed.issues.length === 0) payload.issues.push({ code: 'invalid_type', expected: 'nonoptional', input: undefined, path: [key] })
    return
  }
  if (parsed.value !== undefined || present) result[key] = parsed.value
}
